import { Component, ElementRef, Inject, OnInit, Renderer2 } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LOCAL_STORAGE } from '@ng-toolkit/universal';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ConstantService } from 'src/providers/constants';
import { CoursesService } from 'src/providers/courses.service';
import { DashboardService } from 'src/providers/dashboard.service';
import { LoginService } from 'src/providers/login.service';
import { ThanksDialogueComponent } from '../thanks-dialogue/thanks-dialogue.component';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer, Meta, Title } from '@angular/platform-browser';
import { CourseCouponDialog } from '../home-new/home-new.component';
import { MatDialog } from '@angular/material/dialog';
import { LoginModal } from '../header/header.component';
import { CartService } from 'src/providers/cart.service';
import { JSONIDService } from 'src/providers/schema';
import { DOCUMENT } from '@angular/common';
import { Config } from '../components/faqs/faqs.component';
import { GoogleTagManagerService } from 'src/providers/google-tag-manager.service';

declare var $: any;

@Component({
  selector: 'app-main-neet',
  templateUrl: './main-neet.component.html',
  styleUrls: ['./main-neet.component.scss']
})


export class MainNeetComponent implements OnInit {
  config!: Config;
  options: Config = { multi: false };
  activeCourseTab: any;
  selectedCourses: any[] = [];
  customCourseObj: any;
  yearFilter1: any = '2024';
  totalActualPrice: number = 0;
  totalOfferPrice: number = 0;
  cartArray: any[] = []
  constructor(public constantsService: ConstantService, public coursesService: CoursesService,
    public elementRef: ElementRef, public formBuilder: FormBuilder, @Inject(LOCAL_STORAGE) public sessionStorage: any,
    public loginService: LoginService, public dashboardService: DashboardService, public deviceService: DeviceDetectorService,
    public constantService: ConstantService, public router: Router, public matSnackBar: MatSnackBar, public sanitizer: DomSanitizer,
    @Inject(DOCUMENT) private dom: any, public dialog: MatDialog, public cartService: CartService, public homeSrvice: JSONIDService,
     private titleService: Title, private metaService: Meta, public renderer2: Renderer2,   @Inject(DOCUMENT) private _document:any,
          public gtmService: GoogleTagManagerService
  ) {

  }

  counsellingForm!: FormGroup;
  token: any;
  userData: any;

  slider1: any[] = [
    { img: 'https://media.iquanta.in/ui_images/new-home/Rishi-Mittal.jpg', video: 'd8Datuvi4L4', percent: 'CAT 100%iler', name: 'Rishi Mittal' },
    { img: 'https://media.iquanta.in/ui_images/new-home/mayank.jpg', video: 'v8O8ELvatPc', percent: 'CAT 99.76%iler', name: 'Mayank' },
    { img: 'https://media.iquanta.in/ui_images/new-home/Rahul-Agrawal.jpg', video: 'GIrpNkOa8kQ', percent: 'CAT 99.92%iler', name: 'Rahul Agrawal' },
    { img: 'https://media.iquanta.in/ui_images/new-home/Karal-Maheshwari.jpg', video: 'FjQPFPxlEjc', percent: 'CAT 99%iler', name: 'Karal Maheshwari' },
    { img: 'https://media.iquanta.in/ui_images/new-home/Kislay-Jha.jpg', video: 'uUUseqANr7w', percent: 'CAT 99.96%iler', name: 'Kislay Jha' },
    { img: 'https://media.iquanta.in/ui_images/new-home/Karan-Dutta.jpg', video: 'U7v8MmhfaOQ', percent: 'CAT 99.56%iler', name: 'Karan Dutta' },
    { img: 'https://media.iquanta.in/ui_images/new-home/topper2.jpg', video: '0udGFVgMd84', percent: 'CAT 99.5%iler', name: '' },
    { img: 'https://media.iquanta.in/ui_images/new-home/topper1.jpg', video: 'zHxUBf-yOhk', percent: 'CAT 99.97%iler', name: '' }
  ]

  topperListFeedback: any[] = [
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-01.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-02.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-03.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-04.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-05.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-06.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-07.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-08.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-09.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-10.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-11.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-12.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-13.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-14.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-15.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-16.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-17.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-18.webp',
  ]

  successStories: any[] =
    [{ img: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/gursimranprofile-66e81bb7923eb.webp' },
    { img: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/aayishrofile-66e81bb5cb55e.webp' },
    { img: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/karalprofile-66e81bb5d72c5.webp' },
    { img: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/avinashprofile-66e81bb42ccb0.webp' },
    { img: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/shubashishprofile-66e81bb414823.webp' },
    { img: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/biswaruoprofile-66e81bb2746bb.webp' },
    { img: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/gautamprofile-66e81bb28b1c2.webp' },
    { img: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/gursimranprofile-66e81bb7923eb.webp' },
    ]

    jee2024: any[] =[
      { img: 'https://media.iquanta.in/ui_images/neet/neet-result-1.webp', name: 'Manav Priyadarshi', Marks: '720/720', Registration: '' },
      { img: 'https://media.iquanta.in/ui_images/neet/neet-result-2.webp', name: 'Himanshu', Marks: '715/720', Registration: '' },
      { img: 'https://media.iquanta.in/ui_images/neet/neet-result-3.webp', name: 'Md. Aryaan Taariq ', Marks: '696/720', Registration: '' },
      { img: 'https://media.iquanta.in/ui_images/neet/neet-result-4.webp', name: 'Lovisha Mahajan ', Marks: '686/720', Registration: '' },
      { img: 'https://media.iquanta.in/ui_images/neet/neet-result-07.png', name: 'Satirtha Basak ', Marks: '686/720', Registration: '' },
      { img: 'https://media.iquanta.in/ui_images/neet/neet-result-09.png', name: 'Nikhil Gupta ', Marks: '680/720', Registration: '' },
      { img: 'https://media.iquanta.in/ui_images/neet/neet-result-08.png', name: 'Zibran ', Marks: '677/720', Registration: '' },
      { img: 'https://media.iquanta.in/ui_images/neet/neet-result-5.webp', name: 'Sudipta Karmakar', Marks: '674/720', Registration: '' },
      { img: 'https://media.iquanta.in/ui_images/neet/neet-result-6.webp', name: 'Abhay Tiwari ', Marks: '665/720', Registration: '' },
    ]
  
    faqList:any[] = [
      {
        name: 'Which is the best online course for NEET?',
        iconClass: 'fa fa-code',
        active: true,
        submenu: [
          {answer: "iQuanta NEET Online Courses are considered the best for preparation. It offers flexible learning with unlimited mocks, personalised guidance and quick doubt-resolution support.", subanswers: [] },
        ]
      },
       
      {
        name: 'Which online coaching is best for NEET?',
        iconClass: 'fa fa-mobile',
        active: false,
        submenu: [
          {answer: 'The best NEET online coaching is iQuanta as it has unique features such as 24*7 doubt solving, dual pedagogy where one learns through live and application classes, personalised mentorship, mock test and analysis, relevant content, and other features. ', subanswers: [] },
        ]
      },
  

  
      {
        name: 'Is iQuanta online or offline?',
        iconClass: 'fa fa-globe',
        active: false,
        submenu: [
          {answer: "iQuanta coaching is available online as well offline. So if you want to save time and learn online then you can join the online NEET course otherwise you can also enroll to the offline centres of iQuanta for NEET preparation.", subanswers: [] },
                 ]
      },
  
      {
        name: 'Can I clear NEET with online coaching?',
        iconClass: 'fa fa-globe',
        active: false,
        submenu: [
          {answer: 'Although dedicated self preparation definitely helps you score good marks but seeing the intensifying you need a levelled up strategy to be amongst the top candidates for NEET exam. So NEET online coaching gives you an extra push and coaching institutes like iQuanta prepares you to be amongst the handful students securing admission to top medical institutions. You get personalised mentorship from NEET experts who help you throughout your preparation journey apart from this they are there to assist you 24*7 for doubt solving.Although dedicated self preparation definitely helps you score good marks but seeing the intensifying you need a levelled up strategy to be amongst the top candidates for NEET exam. So NEET online coaching gives you an extra push and coaching institutes like iQuanta prepares you to be amongst the handful students securing admission to top medical institutions. You get personalised mentorship from NEET experts who help you throughout your preparation journey apart from this they are there to assist you 24*7 for doubt solving.', subanswers: [] },
        ]
      },
      {
        name: 'How are the NEET Online courses structured?',
        iconClass: 'fa fa-globe',
        active: false,
        submenu: [
          {answer: 'The NEET Online course offers live classes for conceptual clarity and practising problems with recordings and study materials. You can also access realistic mock tests with AI analysis and 24/7 help with your doubts.', subanswers: [] },
        ]
      },
      {
        name: "Do you cover the entire NEET syllabus in the NEET online coaching?",
        iconClass: 'fa fa-globe',
        active: false,
        submenu: [
          {answer: "Yes. Our NEET online coaching covers the latest syllabus across all three subjects, i.e. Physics, Chemistry, and Biology.", subanswers: [] },
        ]
      },

      {
        name: 'What if I miss a live class in NEET coaching?',
        iconClass: 'fa fa-globe',
        active: false,
        submenu: [
          {answer: 'All live sessions of the NEET online course are recorded and available in the learner’s dashboard. You can access them anytime to catch up on missed classes or for revision.', subanswers: [] },
        
        ]
      },
  
      {
        name: 'How do the Live Application Classes of NEET coaching work?',
        iconClass: 'fa fa-globe',
        active: false,
        submenu: [
          {answer: 'After you learn the concepts in a live class, we have another live session called an Application Class. Here, faculty solve practice questions of all difficulty levels. Students can get their doubts resolved in real time for better clarity.', subanswers: [] },
        
        ]
      },

      {
        name: 'How does the 24×7 Doubt Solving feature in the NEET Course function?',
        iconClass: 'fa fa-globe',
        active: false,
        submenu: [
          {answer: 'You can ask your doubts anytime from anywhere. NEET online courses offers a 24×7 Doubt Solving feature where you get a detailed solution within 15 minutes.', subanswers: [] },
        ]
      },
      {
        name: 'What is the role of a Personal Mentor in NEET coaching?',
        iconClass: 'fa fa-globe',
        active: false,
        submenu: [
          {answer: 'iQuanta NEET online course offers personalised mentorship where experienced teachers will guide you by creating your study plan, providing feedback and subject strategies. This can boost your confidence and motivation for NEET.', subanswers: [] },
        ]
      },
  
      {
        name: 'What study materials in the NEET course do I receive?',
        iconClass: 'fa fa-globe',
        active: false,
        submenu: [
          {answer: 'The NEET coaching includes resources like PDF Notes, Kota-style Study Material, NEET Level Books, Daily Practice Papers (DPPs), and AI-based Mock Tests with instant analysis and video solutions.', subanswers: [] },
        ]
      },
      {
        name: 'How are AI-based Mock Tests beneficial?',
        iconClass: 'fa fa-globe',
        active: false,
        submenu: [
          {answer: 'iQuanta NEET mock tests are similar to the real NEET exam and provide you with a detailed breakdown of your performance.', subanswers: [] },
        ]
      },

  
      {
        name: 'Can i talk to someone at iQuanta for information about NEET online coaching?',
        iconClass: 'fa fa-globe',
        active: false,
        submenu: [
          {answer: 'For any course related information to NEET online coaching you can contact our counsellors at -<br> <a href="tel:+91 8527172937">+91 8527172937</a>', subanswers: [] },
        ]
      },
      {
        name: 'How is IQuanta different from other NEET coaching platforms?',
        iconClass: 'fa fa-globe',
        active: false,
        submenu: [
          {answer: 'iQuanta offers features and facilities that are rarely offered in any other NEET online coaching platform. This includes 24×7 Doubt-Solving, Live Application, Personal Mentorship, and affordable courses.', subanswers: [] },
        ]
      },
      {
        name: 'What is the duration of the NEET course?',
        iconClass: 'fa fa-globe',
        active: false,
        submenu: [
          {answer: 'The duration of our NEET courses is usually between 1 to 2 years, depending on which class you are in when you sign up.', subanswers: [] },
        ]
      },

  
    ];



      mergeConfig(options: Config) {
        // 기본 옵션
        const config = {
          // selector: '#accordion',
          multi: true
        };
    
        return { ...config, ...options };
      }
    
    
      toggle(index: number) {
        if (!this.config.multi) {
          this.faqList.filter(
            (menu, i) => i !== index && menu.active
          ).forEach(menu => menu.active = !menu.active);
        }
    
        this.faqList[index].active = !this.faqList[index].active;
      }




    viewCount: any = 16;
    viewCount1: any = 16;
    viewCount2: any = 16;
    viewCount3: any = 24;
    viewCount4: any = 24;
    viewCount5: any = 24;
    viewCount6: any = 24;
    viewCount7: any = 24;
    viewCount8: any = 24;



    viewMore(val: any) {
      
        if (this.viewCount2 < this.jee2024.length) {
          this.viewCount2 = this.viewCount1 + 24;
        }
  
    }
  
    viewLess(val: any) {
      if (val == '1') {
        this.viewCount = 24;
      } else if (val == '2') {
        this.viewCount1 = 24;
      } else if (val == '3') {
        this.viewCount2 = 24;
      } else if (val == '4') {
        this.viewCount3 = 24;
      } else if (val == '5') {
        this.viewCount4 = 24;
      } else if (val == '6') {
        this.viewCount5 = 24;
      } else if (val == '7') {
        this.viewCount6 = 24;
      } else if (val == '8') {
        this.viewCount7 = 24;
      } else if (val == '9') {
        this.viewCount8 = 24;
      }
  
    }

  examList: any[] = ['CAT', 'GDPI', 'GMAT', 'XAT', 'CMAT', 'MICAT']
  examList1: any[] = ['CUET UG', 'CUET PG', 'IPMAT', 'CLAT', 'IIT']
  callBackForm!: FormGroup;
  yearFilterMyOc: any = '2025';
  json1: any;
  json2: any;
  json3: any;
  json4: any;
  json5: any;
counsellingForm1!: FormGroup;

viewMoreClass(){
  this.sessionStorage.setItem('pageUrl', this._document.URL)
  this.router.navigate(['/dashboard/classes'])

}

  ngOnInit(): void {
    this.tableData = this.constantsService.courseComparisonneet;
    this.json1 = this.homeSrvice.NeetBreadcrumbList;
    this.json2 = this.homeSrvice.NeetProduct;
    this.config = this.mergeConfig(this.options);
    // AOS.init();
  //  this.gtmService.loadGTM('AW-10805359252')
  // Meta Data
    this.titleService.setTitle("NEET Course 2026 | NEET Online Coaching");
    this.metaService.updateTag( 
    { name: 'description', content: "Get the best NEET online coaching at iQuanta and ace your NEET preparation with expert faculty, live classes, and study materials for proven success in NEET Course 2026." }); 
    this.metaService.updateTag( 
    { name: 'keywords', content: 'neet online coaching,neet preparation,neet coaching,neet course,neet online course,best neet course,best neet coaching,best neet coaching in india,NEET 2026 Course,NEET Course 2026' });
// Canonical Link
    const head = this.dom.getElementsByTagName('head')[0];
    var element: HTMLLinkElement = this.dom.createElement('link') as HTMLLinkElement
    head.appendChild(element);
    element.setAttribute('rel', 'canonical')
    element.setAttribute('href', 'https://www.iquanta.in/neet-coaching')
// Facebook
    this.metaService.updateTag(
      { property: 'og:type', content: "website" })
    this.metaService.updateTag(
      { property: 'article:publisher', content: "https://facebook.com/iquanta.in" })
    this.metaService.updateTag(
      { property: 'og:title', content: "NEET Course 2026 | NEET Online Coaching" })
    this.metaService.updateTag(
      { property: 'og:url', content: 'https://www.iquanta.in/neet-coaching' })
    this.metaService.updateTag(
      { property: 'og:description', content: "Get the best NEET online coaching at iQuanta and ace your NEET preparation with expert faculty, live classes, and study materials for proven success in NEET Course 2026." });
    this.metaService.updateTag(
      { property: 'og:image:height', content: '720' })
    this.metaService.updateTag(
      { property: 'og:image:width', content: '1280' })
    this.metaService.updateTag(
      { property: 'og:image:type', content: 'image/webp' })
    this.metaService.updateTag(
      { property: 'og:image', content: 'https://www.iquanta.in/blog/wp-content/uploads/2024/12/neet-coaching.webp' })
// Article Publish Time
    this.metaService.updateTag(
      { property: 'article:published_time', content: '2024-12-22T11:48:33+00:00' })
    this.metaService.updateTag(
      { property: 'article:modified_time', content: '2025-05-09T11:42:33+00:00' })
// Twitter
    this.metaService.updateTag(
      { property: 'twitter:label2', content: "Est. reading time" })
    this.metaService.updateTag(
      { property: 'twitter:data2', content: "10 Minutes" })
    this.metaService.updateTag(
      { property: 'twitter:title', content: "NEET Course 2026 | NEET Online Coaching" })
    this.metaService.updateTag(
      { property: 'twitter:url', content: 'https://www.iquanta.in/neet-coaching' })
    this.metaService.updateTag(
      { property: 'twitter:description', content: "Get the best NEET online coaching at iQuanta and ace your NEET preparation with expert faculty, live classes, and study materials for proven success in NEET Course 2026" });
    this.metaService.updateTag(
      { property: 'twitter:image', content: 'https://www.iquanta.in/blog/wp-content/uploads/2024/12/neet-coaching.webp' })
    this.metaService.updateTag(
      { property: 'twitter:image:height', content: '720' })
    this.metaService.updateTag(
      { property: 'twitter:image:type', content: 'image/webp' })
    this.metaService.updateTag(
      { property: 'twitter:image:width', content: '1280' })

    this.counsellingForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', Validators.compose([Validators.required, Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$')])],
      mobile: ['', Validators.compose([Validators.required, Validators.pattern('^[6-9]{1}[0-9]{9}$')])],
      year: ['', Validators.required],
      time: ['', Validators.required]
    })
     this.counsellingForm1 = this.formBuilder.group({
          name: ['', Validators.required],
          email: ['', Validators.compose([Validators.required, Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$')])],
          mobile: ['', Validators.compose([Validators.required, Validators.pattern('^[6-9]{1}[0-9]{9}$')])],
          year: ['', Validators.required],
        })
    this.token = this.sessionStorage.getItem('usertoken');
    if (this.token) {
      this.userData = JSON.parse(this.sessionStorage.getItem('userData'));
    }

    this.callBackForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', Validators.compose([Validators.required, Validators.email])],
      phone: ['', Validators.compose([Validators.required, Validators.pattern('^[6-9]{1}[0-9]{9}$')])],
      year: ['', Validators.required],
    })
    this.getProfileData()
    this.getHomePageCourses('NEET', 'landingpage')
    this.getNoti()
  }


  selectedImg:any;
  selectedIndex:any = 0;
  showImages:boolean  = false;
  openGallery(ind:any){
    this.selectedIndex = ind;
    this.selectedImg = this.testimonialsList[ind].bigimg;
    this.showImages = true;
    $('#GalleryModal1').modal('show')
  }

  closeenquiry() {
    this.showEnquiryBtn = false
  }
  showEnquiryBtn: boolean = true;

  prev(){
    if(this.selectedIndex > 0){
      this.selectedIndex--;
    this.selectedImg = this.testimonialsList[this.selectedIndex].bigimg
    }
  }

   sendEventToGTM() {
      // const s = this.renderer2.createElement('script');
      // s.text = `function gtag_report_conversion(url) {
      //   var callback = function () {
      //     if (typeof(url) != 'undefined') {
      //       window.location = url;
      //     }
      //   };
      //   gtag('event', 'conversion', {
      //      'send_to': 'AW-10805359252/LUfvCL_R_6kaEJTlsqAo',
      //   'event_callback': callback
      //   });
      //   return false;`;
      // this.renderer2.appendChild(this._document.body, s);
    }
  
    addInternalCRMLead1(typ: any) {
      this.selectedCategory.forEach((cat: any) => {
        let medium: any;
        let source: any;
        let campaign: any;
        if (this.sessionStorage.getItem('utmLink')) {
          this.sessionStorage.getItem('utmLink').split('&').forEach((item: any) => {
            if (item.includes('utm_medium')) {
              medium = item.split('=')[1]
            }
            if (item.includes('utm_source')) {
              source = item.split('=')[1]
            }
            if (item.includes('utm_campaign')) {
              campaign = item.split('=')[1]
            }
          })
        }
        let reqObj = {
          "name":  this.counsellingForm1.value.name,
          "firstName":  this.counsellingForm1.value.name,
          "phone": this.counsellingForm1.value.mobile,
          "email": this.counsellingForm1.value.email,
          "countryCode": 91,
          "source": "Website",
          "medium": "NEET",
          "campaign": 'New form',
          "orgId": "66dec57ce200bc89284602d6",
          "uid": '66dec57ce200bc89284602d6',
          "userId": this.userData ? this.userData.id : 9999,
          "registrationDate": this.userData ? new Date(this.userData.date_joined).valueOf() : new Date().valueOf(),
          "pageLocation": this.dom.URL,
          "registrationChannel": this.sessionStorage.getItem('utmLink') ? this.sessionStorage.getItem('utmLink') : this.dom.URL,
          "registrationDevice": this.deviceService.deviceType,
          "customFields": {
            "exam": 'NEET',
            "examCategory": 'Medical',
            "examTargetYear":  this.counsellingForm1.value.year,
            "leadPriority": "Platinum",
          },
          "ipAddress": this.sessionStorage.getItem('ipAddress'),
          dataSource: [
            {
              utmSource: source,
              utmMedium: medium,
              utmCampaign: campaign,
              utmAdContent: "",
              "source": "Website",
              "medium": "NEET",
              "campaign": 'New form',
              "pageLocation": this.dom.URL,
              adContent: "",
              browser: this.deviceService.browser,
              browser_version: this.deviceService.browser_version,
              device: this.deviceService.device,
              deviceType: this.deviceService.deviceType,
              orientation: this.deviceService.orientation,
              os: this.deviceService.os,
              os_version: this.deviceService.os_version,
              platformId: this.deviceService['platformId'],
              ua: this.deviceService.ua,
              userAgent: this.deviceService.userAgent,
              "ipAddress": this.sessionStorage.getItem('ipAddress'),
            },
          ],
        }
  
        this.dashboardService.addCRMLead(reqObj).subscribe(res => {
          if (res.success) {
            this.selectedCategory = [];
            this.selectedExams = [];
            this.selectedExams1 = [];
  
          } else {
            this.selectedCategory = [];
            this.selectedExams = [];
            this.selectedExams1 = [];
          }
        }, err => {
          if (err.statusText == 'Unknown Error') {
            this.callBackLead(reqObj)
          }
        })
      })
    }
  
    submitForm() {
  
      if (this.counsellingForm1.valid) {
        let reqObj = {
          name: this.counsellingForm1.value.name,
          email: this.counsellingForm1.value.email,
          phone_no: this.counsellingForm1.value.mobile,
          course: 'NEET' ,
          year: this.counsellingForm1.value.year,
          time_slot: '',
        }
  
        this.coursesService.homeEnquiry(reqObj).subscribe(res => {
          if (res.success || res.id) {
            this.selectedCategory.push('After 12th')
            this.addInternalCRMLead1('Book Free Counselling Session')
            this.sendEventToGTM()
            const dialogRef = this.dialog.open(ThanksDialogueComponent, {
              width: '330px',
              panelClass: 'thanks-modal'
  
            })
            dialogRef.afterClosed().subscribe(res => {
              location.reload()
            })
          } else {
  
          }
        }, err => {
          this.matSnackBar.open(err.error.error, 'OK', {
            verticalPosition: 'top',
            duration: 3000,
            panelClass: 'snack-error'
          })
        })
      }
      else {
        if (this.counsellingForm1.controls['name'].hasError('required')) {
          this.matSnackBar.open('Name is required', 'OK', {
            verticalPosition: 'top',
            duration: 3000,
            panelClass: 'snack-error'
          })
        } else if (this.counsellingForm1.controls['email'].hasError('required')) {
          this.matSnackBar.open('Email is required', 'OK', {
            verticalPosition: 'top',
            duration: 3000,
            panelClass: 'snack-error'
          })
        } else if (this.counsellingForm1.controls['mobile'].hasError('required')) {
          this.matSnackBar.open('Phone Number is required', 'OK', {
            verticalPosition: 'top',
            duration: 3000,
            panelClass: 'snack-error'
          })
        }
       
        else if (this.counsellingForm1.controls['year'].hasError('required')) {
          this.matSnackBar.open('Target Year is required', 'OK', {
            verticalPosition: 'top',
            duration: 3000,
            panelClass: 'snack-error'
          })
        }
       else if (this.counsellingForm1.controls['email'].hasError('pattern')) {
          this.matSnackBar.open('Email is not Valid', 'OK', {
            verticalPosition: 'top',
            duration: 3000,
            panelClass: 'snack-error'
          })
        } else if (this.counsellingForm1.controls['mobile'].hasError('pattern')) {
          this.matSnackBar.open('Phone Number is not Valid', 'OK', {
            verticalPosition: 'top',
            duration: 3000,
            panelClass: 'snack-error'
          })
        }
      }
    }

  next(){
    if(this.selectedIndex < this.testimonialsList.length - 1){
      this.selectedIndex++;
    this.selectedImg = this.testimonialsList[this.selectedIndex].bigimg
    }
  }

  goToLink1(course: any) {
    window.open(course.url, '_blank')
  }

  joinwhatsapp() {
    window.open('https://chat.whatsapp.com/ElYiZ0cdhDuGdTwyA9oxFW', '_blank')
  }


  makeCall(): void {
    window.location.href = 'tel:+918527172937';
  }


  getProfileData() {
    this.loginService.profileData.subscribe(res => {
      this.token = this.sessionStorage.getItem('usertoken');
      if (this.sessionStorage.getItem('userData')) {
        this.userData = JSON.parse(this.sessionStorage.getItem('userData'));
      } else {
        this.userData = '';
        this.token = ''
      }
    })
  }

  addNPF() {
    let reqObj = {
      "secret_key": "bd0f12c20c7949caa22d5635f44c1732",
      "college_id": "5802",
      "name": this.counsellingForm.value.name,
      "field_last_name": '',
      "country_dial_code": "+91",
      "mobile": this.counsellingForm.value.mobile,
      "email": this.counsellingForm.value.email,
      "field_gender": '',
      "field_exam_category": "",
      "field_course_year": this.counsellingForm.value.year,
      "field_exam": 'NEET',
      "source": "Website",
      "medium": 'Home Page',
      "field_lead_priority": 'Platinum',
    }

    this.dashboardService.addLeadSquared(reqObj).subscribe(res => {
      this.counsellingForm.reset()

    })
  }


  getExamCategory() {
    let category: any;
    if (this.examList.includes(this.counsellingForm.value.course)) {
      category = 'MBA';
      this.selectedExams.push(this.counsellingForm.value.course)
    } else {
      category = 'After 12th';
      this.selectedExams1.push(this.counsellingForm.value.course)
    }
    return category;
  }
  selectedCategory: any[] = []
  selectedExams: any[] = []
  selectedExams1: any[] = []
  getExamCategory1() {
    this.addInternalCRMLead('Course Enquiry')
  }

  videoLink: any
  videoPlay(obj: any) {
    this.videoLink = this.sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/' + obj.video + '?rel=0')
    $('#VideoPlayer').modal()
  }

  addInternalCRMLead(typ: any) {
    this.selectedCategory.forEach((cat: any) => {
      let medium: any;
      let source: any;
      let campaign: any;
      if (this.sessionStorage.getItem('utmLink')) {
        this.sessionStorage.getItem('utmLink').split('&').forEach((item: any) => {
          if (item.includes('utm_medium')) {
            medium = item.split('=')[1]
          }
          if (item.includes('utm_source')) {
            source = item.split('=')[1]
          }
          if (item.includes('utm_campaign')) {
            campaign = item.split('=')[1]
          }
        })
      }
      let reqObj = {
        "name": typ == 'Book 1 on 1 Counselling from MBA Experts' ? this.counsellingForm.value.name : this.callBackForm.value.name,
        "firstName": typ == 'Book 1 on 1 Counselling from MBA Experts' ? this.counsellingForm.value.name : this.callBackForm.value.name,
        "phone": typ == 'Book 1 on 1 Counselling from MBA Experts' ? this.counsellingForm.value.mobile : this.callBackForm.value.phone,
        "email": typ == 'Book 1 on 1 Counselling from MBA Experts' ? this.counsellingForm.value.email : this.callBackForm.value.email,
        "countryCode": 91,
        "source": "Website",
        "medium": "Free Counselling",
        "campaign": typ,
        "orgId": "66dec57ce200bc89284602d6",
        "uid": '66dec57ce200bc89284602d6',
        "userId": this.userData ? this.userData.id : 9999,
        "registrationDate": this.userData ? new Date(this.userData.date_joined).valueOf() : new Date().valueOf(),
        "pageLocation": this.dom.URL,
        "registrationChannel": this.sessionStorage.getItem('utmLink') ? this.sessionStorage.getItem('utmLink') : this.dom.URL,
        "registrationDevice": this.deviceService.deviceType,
        "customFields": {
          "exam": 'NEET',
          "examCategory": 'Medical',
          "examTargetYear": typ == 'Book 1 on 1 Counselling from MBA Experts' ? this.counsellingForm.value.year : 2025,
          "leadPriority": "Platinum",
        },
        "ipAddress": this.sessionStorage.getItem('ipAddress'),
        dataSource: [
          {
            utmSource: source,
            utmMedium: medium,
            utmCampaign: campaign,
            utmAdContent: "",
            "source": "Website",
            "medium": "Free Counselling",
            "campaign": typ,
            adContent: "",
            "pageLocation": this.dom.URL,
            browser: this.deviceService.browser,
            browser_version: this.deviceService.browser_version,
            device: this.deviceService.device,
            deviceType: this.deviceService.deviceType,
            orientation: this.deviceService.orientation,
            os: this.deviceService.os,
            os_version: this.deviceService.os_version,
            platformId: this.deviceService['platformId'],
            ua: this.deviceService.ua,
            userAgent: this.deviceService.userAgent,
            "ipAddress": this.sessionStorage.getItem('ipAddress'),
          },
        ],
      }

      this.dashboardService.addCRMLead(reqObj).subscribe(res => {
        if (res.success) {
          this.selectedCategory = [];
          this.selectedExams = [];
          this.selectedExams1 = [];
          this.addLead()

        } else {
          this.selectedCategory = [];
          this.selectedExams = [];
          this.selectedExams1 = [];
        }
      }, err => {
        if (err.statusText == 'Unknown Error') {
          this.callBackLead(reqObj)
        }
      })
    })
  }

  callBackLead(reqObj: any) {
    this.dashboardService.callbackLead(reqObj).subscribe(res => {
      this.selectedCategory = [];
      this.selectedExams = [];
      this.selectedExams1 = [];
    })
  }

  submittedBtn: boolean = false;
  page_loaction: any;
  addLead() {
    let medium: any;
    if (this.sessionStorage.getItem('utmLink')) {
      this.sessionStorage.getItem('utmLink').split('&').forEach((item: any) => {
        if (item.includes('utm_medium')) {
          medium = item.split('=')[1]
        }
      })
    }
    let reqObj = {
      "secret_key": "bd0f12c20c7949caa22d5635f44c1732",
      "college_id": "5802",
      "name": this.callBackForm.value.name,
      "field_last_name": '',
      "country_dial_code": "+91",
      "mobile": this.callBackForm.value.phone,
      "email": this.callBackForm.value.email,
      "field_gender": '',
      "field_exam_category": 'NEET',
      "field_exam": 'NEET',
      "field_course_year": this.callBackForm.value.year,
      "source": "Website " + medium,
      "medium": "Call Back Form",
      "field_lead_priority": 'Gold',
      "field_page_location": this.sessionStorage.getItem('utmLink') ? this.dom.URL + '?' + this.sessionStorage.getItem('utmLink') : this.dom.URL
    }

    this.dashboardService.addLeadSquared(reqObj).subscribe(res => {
      if (res.message == "Mobile number already exists." || res.status == 'Successfully updated') {
        let reqData = {
          "secret_key": "bd0f12c20c7949caa22d5635f44c1732",
          "college_id": "5802",
          "user_id": res.data.user_id,
          "name": this.callBackForm.value.name,
          "field_last_name": '',
          "country_dial_code": "+91",
          "mobile": this.callBackForm.value.phone,
          "email": this.callBackForm.value.email,
          "field_gender": '',
          "field_exam_category": "",
          "field_exam": 'NEET',
          "field_course_year": '',
          "source": "Website " + medium,
          "medium": "Call Back Form",
          "field_lead_priority": 'Gold',
          "field_reinquire": 'Yes',
          "field_page_location": this.sessionStorage.getItem('utmLink') ? this.dom.URL + '?' + this.sessionStorage.getItem('utmLink') : this.dom.URL

        }
        this.dashboardService.updateLeadSquared(reqData).subscribe((res: any) => {
          if (res) {
            this.callBackForm.reset()
          }
        })
      } else {
        this.callBackForm.reset()
      }
    })
  }

  courseEnquiry() {
    if (this.callBackForm.valid) {
      this.submittedBtn = true;
      let reqObj = {
        name: this.callBackForm.value.name,
        email: this.callBackForm.value.email,
        phone_no: this.callBackForm.value.phone,
        course_name: 'NEET',
        year: this.callBackForm.value.year,
        page_location: this.sessionStorage.getItem('utmLink') ? this.dom.URL + '?' + this.sessionStorage.getItem('utmLink') : this.dom.URL
      }
      this.coursesService.callback(reqObj).subscribe(res => {
        // this.dialogRef.close(res)
        if (res.success) {
          this.getExamCategory1()
          $('#ChooseEquiry').modal('hide')
          const dialogRef = this.dialog.open(ThanksDialogueComponent, {
            width: '330px',
            panelClass: 'thanks-modal'

          })
          dialogRef.afterClosed().subscribe(res => {
            location.reload()
          })

          // this.sessionStorage.setItem('dialogCloseTime', new Date().getTime().toString());
        }
      })
    } else {
      this.matSnackBar.open('Please enter valid Details', 'OK', {
        verticalPosition: 'top',
        duration: 3000,
        panelClass: 'snack-error'
      })
    }
  }

  submit() {

    if (this.counsellingForm.valid) {
      let reqObj = {
        name: this.counsellingForm.value.name,
        email: this.counsellingForm.value.email,
        phone_no: this.counsellingForm.value.mobile,
        course: 'NEET',
        year: this.counsellingForm.value.year,
        time_slot: this.counsellingForm.value.time,
      }

      this.coursesService.homeEnquiry(reqObj).subscribe(res => {
        if (res.success || res.id) {
          this.selectedCategory.push(this.getExamCategory())
          this.addInternalCRMLead('Book 1 on 1 Counselling from MBA Experts')
        } else {

        }
      }, err => {
        this.matSnackBar.open(err.error.error, 'OK', {
          verticalPosition: 'top',
          duration: 3000,
          panelClass: 'snack-error'
        })
      })
    }
    else {
      if (this.counsellingForm.controls['name'].hasError('required')) {
        this.matSnackBar.open('Name is required', 'OK', {
          verticalPosition: 'top',
          duration: 3000,
          panelClass: 'snack-error'
        })
      } else if (this.counsellingForm.controls['email'].hasError('required')) {
        this.matSnackBar.open('Email is required', 'OK', {
          verticalPosition: 'top',
          duration: 3000,
          panelClass: 'snack-error'
        })
      } else if (this.counsellingForm.controls['mobile'].hasError('required')) {
        this.matSnackBar.open('Phone Number is required', 'OK', {
          verticalPosition: 'top',
          duration: 3000,
          panelClass: 'snack-error'
        })
      }
      else if (this.counsellingForm.controls['course'].hasError('required')) {
        this.matSnackBar.open('Course is required', 'OK', {
          verticalPosition: 'top',
          duration: 3000,
          panelClass: 'snack-error'
        })
      }
      else if (this.counsellingForm.controls['year'].hasError('required')) {
        this.matSnackBar.open('Target Year is required', 'OK', {
          verticalPosition: 'top',
          duration: 3000,
          panelClass: 'snack-error'
        })
      }
      else if (this.counsellingForm.controls['time'].hasError('required')) {
        this.matSnackBar.open('Time Slot is required', 'OK', {
          verticalPosition: 'top',
          duration: 3000,
          panelClass: 'snack-error'
        })
      } else if (this.counsellingForm.controls['email'].hasError('pattern')) {
        this.matSnackBar.open('Email is not Valid', 'OK', {
          verticalPosition: 'top',
          duration: 3000,
          panelClass: 'snack-error'
        })
      } else if (this.counsellingForm.controls['mobile'].hasError('pattern')) {
        this.matSnackBar.open('Phone Number is not Valid', 'OK', {
          verticalPosition: 'top',
          duration: 3000,
          panelClass: 'snack-error'
        })
      }
    }
  }

  gotosection(val: any) {
    var elemnt: any = document.getElementById(val)
    elemnt.scrollIntoView({ behavior: "smooth" })
    if (val == 'courses') {
      this.activeCourseTab = 'Flagship'
    }
  }

  download() {
    window.open('https://media.iquanta.in/ui_images/iit-new-img/new-learning-1.jpg', '_blank');
  }

  discountAmount: any = 0;
  couponCode: any;
  selectedMenu: any;
  openMenu(val: any) {
    this.selectedMenu = val;
    // this.coursesService.saveSelectedMenu(val)
  }
  notificationList: any[] = [];
  selectedIndicator: any;
  selectedIndicatorIndex: any;
  getNoti() {
    // this.getTestimonials()
    this.coursesService.getNoticeBoardPerPage('NEET').subscribe(res => {
      if (res.success) {
        this.notificationList = res.data;
        this.selectedIndicator = this.notificationList[0];
        this.selectedIndicatorIndex = 0;

      }
    })
  }



  featuresTab: any = 'dual'

  featuresTabChange(val: any) {
    this.featuresTab = val;
  }

  
  slideConfig = {
    "slidesToShow": 4, "slidesToScroll": 4,
    prevArrow: '<button class="slide-arrow prev-arrow"><i class="bi bi-chevron-left"></i></button>',
    nextArrow: '<button class="slide-arrow next-arrow"><i class="bi bi-chevron-right"></i></button>',
    autoplay: false,
    autoplaySpeed: 4000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]



  };

  slideConfig1 = {
    "slidesToShow": 1, "slidesToScroll": 1,
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover: true,
    prevArrow: '<button class="slide-arrow prev-arrow"><i class="bi bi-chevron-left"></i></button>',
    nextArrow: '<button class="slide-arrow next-arrow"><i class="bi bi-chevron-right"></i></button>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  };

  slickInit(e: any) {
  }

  breakpoint(e: any) {
  }

  afterChange(e: any) {
  }

  beforeChange(e: any) {
  }

  playVideoFlag2:boolean = false;
  playVideoFlag1:boolean = false;

  testimonialsList: any[] = [
    { img: 'https://media.iquanta.in/ui_images/neet/neetfeedback1.webp', bigimg: 'https://media.iquanta.in/ui_images/neet/neetfeedback1.webp'},
    { img: 'https://media.iquanta.in/ui_images/neet/neetfeedback2.webp', bigimg: 'https://media.iquanta.in/ui_images/neet/neetfeedback2.webp'},
    { img: 'https://media.iquanta.in/ui_images/neet/neetfeedback3.webp', bigimg: 'https://media.iquanta.in/ui_images/neet/neetfeedback3.webp'},
    { img: 'https://media.iquanta.in/ui_images/neet/neetfeedback4.webp', bigimg: 'https://media.iquanta.in/ui_images/neet/neetfeedback4.webp'},
    { img: 'https://media.iquanta.in/ui_images/neet/neetfeedback5.webp', bigimg: 'https://media.iquanta.in/ui_images/neet/neetfeedback5.webp'},
    { img: 'https://media.iquanta.in/ui_images/neet/neetfeedback6.webp', bigimg: 'https://media.iquanta.in/ui_images/neet/neetfeedback6.webp'},

  ]

  goNext() {
    let index: any;
    this.selectedIndicatorIndex = this.notificationList.indexOf(this.selectedIndicator) + 1
    this.selectedIndicator = this.notificationList[this.notificationList.indexOf(this.selectedIndicator) + 1];
  }

  goBack() {
    this.selectedIndicatorIndex = this.notificationList.indexOf(this.selectedIndicator) - 1
    this.selectedIndicator = this.notificationList[this.notificationList.indexOf(this.selectedIndicator) - 1];
  }

  gotoFooter() {
    window.open(this.selectedIndicator.link, '_blank')
  }

  login() {
    const dialogRef = this.dialog.open(LoginModal, {
      width: '750px',
      panelClass: 'login_modal',
      autoFocus: false
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == 'yes') {

      } else if (typeof (result) == 'object') {
        if (this.sessionStorage.getItem('usertoken')) {
          this.token = this.sessionStorage.getItem('usertoken');
          this.getProfile()
        } else {
          this.userData = result;
          this.token = this.sessionStorage.getItem('usertoken');;
          this.sessionStorage.setItem('userData', JSON.stringify(result));
          this.loginService.userProfile(this.userData)

        }
      }
    });
  }

  getProfile() {
    this.dashboardService.getProfile(this.token).subscribe(res => {
      if (res.success) {
        this.userData = res.data[0];
        this.sessionStorage.setItem('userData', JSON.stringify(this.userData));
        this.sessionStorage.setItem('mockData', JSON.stringify(res.mock_login))
        this.loginService.userProfile(this.userData)
      }
    })
  }

  tableData: any[] = []

  topperList = [
    { img: 'https://media.iquanta.in/ui_images/neet/neet-result-1.webp', },
    { img: 'https://media.iquanta.in/ui_images/neet/neet-result-2.webp',  },
    { img: 'https://media.iquanta.in/ui_images/neet/neet-result-3.webp',  },
    { img: 'https://media.iquanta.in/ui_images/neet/neet-result-4.webp', },
    { img: 'https://media.iquanta.in/ui_images/neet/neet-result-5.webp',  },
    { img: 'https://media.iquanta.in/ui_images/neet/neet-result-6.webp', },
    { img: 'https://media.iquanta.in/ui_images/neet/neet-result-07.png', },
    { img: 'https://media.iquanta.in/ui_images/neet/neet-result-08.png', },
    { img: 'https://media.iquanta.in/ui_images/neet/neet-result-09.png', },
  ]

  playVideoFlag: boolean = false;
  playVideoFlagStory: boolean = false;
  yearFilter: any = '2025';

  coursesArray: any[] = []
  ngAfterViewInit() {
    this.iniSlickJs()
  }

  getHomePageCourses(val: any, type: any) {
    this.coursesArray = [];
    this.evenArray = [];
    this.oddArray = []
    this.activeCourseTab = val;
    this.coursesService.getPagewiseCourses(val, type, '2025').subscribe(res => {
      if (res.success) {
        if (res.data.length > 0) {
          this.coursesArray = res.data[0].course.filter((x: any) => !x.is_rq);
          this.coursesArray.forEach((course: any, index: any) => {
            if (0 === index % 2) {
              this.evenArray.push(course)
            } else {
              this.oddArray.push(course)
            }
          })
        }

      }
    })
  }

  iniSlickJs() {
    const htmlScriptElement3 = document.createElement('script');
    htmlScriptElement3.src = '../../assets/js/home-swiper.js';
    htmlScriptElement3.setAttribute('async', '')
    this.elementRef.nativeElement.appendChild(htmlScriptElement3);
  }


  evenArray: any[] = [];

  oddArray: any[] = [];

  gotolink(val: any) {
    window.open(val, '_blank')
  }

  whyIquantaItem: any = '1';

  changeTabItem(val: any) {
    this.whyIquantaItem = val;
  }

}